import Image from 'next/image';
import useLocale from 'next-translate/useTranslation';

import ButtonLink from '../links/ButtonLink';

export default function CloneYourVoice() {
  const { t } = useLocale('text-to-speech');

  return (
    <div className='bg-white py-24 sm:py-32 sm:pt-20'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='mx-auto max-w-2xl sm:text-center'>
          <h2 className='text-base font-semibold leading-7 text-indigo-600'>
            {t('Instant Voice Cloning')}
          </h2>
          <p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
            {t('Clone your voice with only a few minutes of audio.')}
          </p>
          <p className='mt-6 text-lg leading-8 text-gray-600'>
            {t(
              'Create a voice that sounds just like you and use it to generate speech in any of our 70+ supported languages. Clone your voice from a recording in one language and use it to generate speech in another.',
            )}
          </p>
        </div>
      </div>
      <div className='relative overflow-hidden pt-16'>
        <div className='mx-auto max-w-4xl px-6 lg:px-8'>
          <Image
            src='/images/clone-voice-with-ai.jpg'
            alt='Instant Voice Cloning'
            className='mb-[-12%] rounded-xl shadow-2xl ring-1 ring-gray-900/10'
            width={2432}
            height={1442}
          />
          <div className='relative' aria-hidden='true'>
            <div className='absolute -inset-x-20 bottom-0 bg-gradient-to-t from-white pt-[7%]' />
          </div>
        </div>
      </div>
      <div className='mt-24 sm:flex sm:justify-center'>
        <div className='rounded-md shadow'>
          <ButtonLink
            href='/login?preset=tts'
            variant='dark'
            className='flex w-full items-center justify-center rounded-md border border-transparent bg-primary-600 px-8 py-3 text-base font-medium text-white hover:bg-primary-700 md:px-10 md:py-4 md:text-lg'
          >
            {t('Try it yourself')}
          </ButtonLink>
        </div>
      </div>
    </div>
  );
}
